import { render, staticRenderFns } from "./EmergencyOrderFilters.vue?vue&type=template&id=72212c8a"
import script from "./EmergencyOrderFilters.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports